<a
  class="web-menu-button"
  [ngClass]="{
    'web-menu-button--selected': isSelected(),
  }"
  [href]="href()"
>
  <ng-content></ng-content>
</a>
